import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CommunityIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M9.84959 4.26367C9.84959 2.46408 8.38551 1 6.58592 1C2.25619 1.1793 2.25742 7.34875 6.58592 7.52734C8.38557 7.52734 9.84959 6.06326 9.84959 4.26367Z"
        fill="currentColor"
      />
      <path
        d="M12.1719 14.1172V13.1133C11.8642 5.70092 1.30498 5.70666 1 13.1133V14.1171C1 14.6025 1.39352 14.9961 1.87891 14.9961H11.293C11.7784 14.9961 12.1719 14.6026 12.1719 14.1172Z"
        fill="currentColor"
      />
      <path
        d="M28.6778 4.26367C28.6778 2.46408 27.2137 1 25.4141 1C21.0844 1.1793 21.0856 7.34875 25.4141 7.52734C27.2137 7.52734 28.6778 6.06326 28.6778 4.26367Z"
        fill="currentColor"
      />
      <path
        d="M25.4141 7.52734C22.334 7.52734 19.8282 10.0332 19.8282 13.1133V14.1171C19.8282 14.6025 20.2217 14.9961 20.7071 14.9961H30.1211C30.6065 14.9961 31 14.6025 31 14.1171V13.1133C31 10.0332 28.4942 7.52734 25.4141 7.52734Z"
        fill="currentColor"
      />
      <path
        d="M6.52346 16.9414C6.52346 16.8787 6.52463 16.8163 6.5258 16.7539H4.76799C4.69803 20.5215 6.52439 23.9253 9.3526 25.9981C9.60525 25.4618 9.92096 24.9609 10.2901 24.5047C8.00213 22.7747 6.52346 20.0309 6.52346 16.9414Z"
        fill="currentColor"
      />
      <path
        d="M12.1213 8.29264C14.459 7.19787 17.541 7.19787 19.8787 8.29264C20.2955 7.81457 20.773 7.39082 21.2993 7.03352C18.1882 5.28162 13.8118 5.28168 10.7008 7.03352C11.227 7.39082 11.7045 7.81463 12.1213 8.29264Z"
        fill="currentColor"
      />
      <path
        d="M25.4742 16.7539C25.5425 19.8939 24.0445 22.7461 21.7099 24.5047C22.079 24.9608 22.3947 25.4618 22.6474 25.9981C25.4755 23.9255 27.302 20.5214 27.232 16.7539H25.4742Z"
        fill="currentColor"
      />
      <path
        d="M19.2637 20.2676C19.2637 18.468 17.7996 17.0039 16 17.0039C11.6703 17.1832 11.6715 23.3526 16 23.5312C17.7996 23.5312 19.2637 22.0672 19.2637 20.2676Z"
        fill="currentColor"
      />
      <path
        d="M16 23.5312C12.9199 23.5312 10.4141 26.0371 10.4141 29.1171V30.1211C10.4141 30.6065 10.8076 31 11.293 31H20.7071C21.1925 31 21.586 30.6065 21.586 30.1211V29.1172C21.5859 26.0371 19.0801 23.5312 16 23.5312Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
